import React from 'react'
import styled from 'styled-components'
import { UserCircle } from '@styled-icons/boxicons-regular/UserCircle'

const WrapperIcon = styled.span`
  display: flex;
  justify-content: center;
  width: 100%;
`

const UserStyled = styled(UserCircle)`
  color: red;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const WrapperForm = styled.div`
  width: 30%;
`

export const P = styled.p`
  font-size: 24px;
  font-weight: bold;
`

export const Button = styled.button`
  outline-color: #002d63;
  width: 32%;
  height: 48px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  margin-left: 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 4px;
  align-self: self-end;
  color: #ffffff;
  background-color: #25a37b;
`

export const UserIcon = () => (
  <WrapperIcon>
    <UserStyled size={96} />
  </WrapperIcon>
)
